export default __webpack_public_path__ + "static/media/lightPicture.d5b716bc.jpg";